$(document).ready(function() {
  $(document).on('click', '.commissions-manage-component .expand-collapse-commissions-rows-js', function() {
    const commissionRows = $(this).closest('table').find('.commissions-row-js');
    const collapsed = commissionRows.first().hasClass('d-none');
    if (collapsed) commissionRows.removeClass('d-none');
    else commissionRows.addClass('d-none');
  });
});
